<template>
  <div class="distributor-box back-fff p20">
    <div class="basicIn_box">
      <Spin v-if="loading" fix></Spin>
      <div class="content-box" v-else>
        <p class="item">
          <span class="label">{{ $t('key1005511') }}</span>
          {{ basicInformationForm.name }}
        </p>
        <p class="item">
          <span class="label">{{ $t('key1005512') }}</span>
          {{ currencyName }}
          <span class="item-s" @click="modifyBtn('currency')">{{ $t('key1005513') }} ></span>
        </p>
        <p class="item">
          <span class="label">{{ $t('key1003100') }}</span>
          {{ basicInformationForm.mobile }}
          <span class="item-s" @click="modifyBtn('mobile')">{{ $t('key1005514') }} ></span>
        </p>
        <p class="item">
          <span class="label">{{ $t('key1000066') }}</span>
          {{ basicInformationForm.telephone }}
        </p>
        <p class="item">
          <span class="label">{{ $t('key1000068') }}</span>
          {{ basicInformationForm.email }}
          <span class="item-s" @click="modifyBtn('email')">{{ $t('key1005515') }} ></span>
        </p>
      </div>
    </div>
    <!--编辑币种弹窗-->
    <changeCurrencyModal ref="changeCurrency" @updateData="getSystemCurrencyData()"></changeCurrencyModal>
  </div>
</template>

<script>
import api from '@/api/';
import Mixin from "@/components/mixin/common_mixin";
import changeCurrencyModal from "@/components/common/changeCurrencyModal";
import {currencyNameCode, getCurrencyData} from "@/utils/common";
import {getErpconfig} from "@/utils/user";

export default {
  name: 'basicInformation',
  mixins: [Mixin],
  data() {
    return {
      loading: false,
      basicInformationForm: {
        name: '', // 联系人
        currency: '', // 币种
        mobile: '', // 手机号
        telephone: '', // 电话
        email: '' // 邮箱
      },
      currencyName: '',
      currency: null,
    };
  },
  created() {
    this.initFun();
  },
  computed: {
    // 获取当前登录用户的信息
    userInfo() {
      if (this.$store.state.erpConfig) {
        return this.$store.state.erpConfig.userInfo;
      } else {
        return '';
      }
    }
  },
  methods: {
    // 初始化接口数据
    initFun() {
      (async () => {
        await getCurrencyData();
      })();
      this.getName();
      this.getSystemCurrencyData();
    },
    // 获取分销商名称
    getName() {
      let v = this;
      if (v.getPermission('get_ymsDistributorMerchant')) {
        v.loading = true;
        v.axios.get(api.get_ymsDistributorMerchant).then(response => {
          v.loading = false;
          if (response.data.code === 0) {
            let data = response.data.datas;
            v.basicInformationForm.name = data.name;
            v.basicInformationForm.mobile = v.userInfo.mobile;
            v.basicInformationForm.telephone = v.userInfo.telephone;
            v.basicInformationForm.email = v.userInfo.email;
          }
        });
      } else {
        v.gotoError();
      }
    },
    // 修改手机、修改邮箱
    modifyBtn(type) {
      localStorage.setItem('distributorActiveName', '2-1');
      if (type === 'mobile') {
        this.$router.push('/modifyMobile');
      } else if (type === 'email') {
        this.$router.push('/modifyMailbox');
      } else if (type === 'currency') {
        this.$refs['changeCurrency'].initCurrencyData('editDistributor', 3, this.currency);
      }
    },
    // 获取系统配置的币种
    getSystemCurrencyData() {
      let v = this;
      let currency = v.$store.state.erpConfig.currency;
      if (currency) {
        v.currencyName = currencyNameCode(currency);
        v.currency = currency;
      }
      v.axios.post(api.post_erpCommonSettingParam_queryMerchantByParamKeys, ['ymsDistributorCurrency']).then(response => {
        if (response.data.code === 0) {
          let data = response.data.datas;
          if (data.length > 0) {
            data.map((item) => {
              if (item.paramKey === 'ymsDistributorCurrency') {
                v.currency = item.paramValue;
                v.currencyName = currencyNameCode(item.paramValue);
                getErpconfig('distributor',true);
                v.$forceUpdate();
              }
            });
          }
        }
      });
    }
  },
  components: {
    changeCurrencyModal
  }
};
</script>

<style lang="less" scoped>
.basicIn_box {
  width: 100%;
  height: 549px;
  position: relative;

  .content-box {
    font-size: 14px;
    color: #757575;

    .item {
      margin-bottom: 15px;

      .label {
        color: #515a6e;
        text-align: right;
        padding-right: 5px;
      }

      .item-s {
        margin-left: 15px;
        font-size: 13px;
        color: #ff6700;
        cursor: pointer;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
}
</style>
